module.exports = __webpack_public_path__ + "static/media/settings.b873d5e8.svg";